import { InitialTpaPlugins } from './types';
import { AdditionalTimeSlots } from './additional-time-slots/controller';

export const initialTpaPlugins = async (context: InitialTpaPlugins) => {
  await new AdditionalTimeSlots(context).runListeners();
};
